<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch23"></a><a id="page_24"></a><a href="#/contents#ch23"><b>Food!</b></a></h2>
<p class="noindent"><span>Gerber once tried to market premade foods for adults.</span></p>
<p class="noindent"><span>Until about 200 years ago, people in many Asian countries used bricks of tea as money.</span></p>
<p class="noindent"><span>Huey Lewis’s grandfather invented the red wax sealant used on some varieties of cheese.</span></p>
<p class="noindent"><span>Most widely used herb in the world: parsley.</span></p>
<p class="noindent"><span>Throughout <i>The Big Lebowski</i>, the Dude (Jeff Bridges) drinks nine White Russians.</span></p>
<p class="noindent"><span>There are more than 20,000 brands of beer worldwide.</span></p>
<p class="noindent"><span>Seventeenth-century Italian cardinal Jules Mazarin took his personal chocolate-maker with him everywhere.</span></p>
<p class="noindent"><span>Before he made it big in films, actor Alan Ladd operated a hot-dog stand called Tiny’s.</span></p>
<p class="noindent"><span>The world’s most expensive spice: Spanish saffron. It can cost more than $1,000 a pound.</span></p>
<p class="noindent"><span>In the 1600s, thermometers were often filled with brandy instead of mercury.</span></p>
<p class="noindent"><span>When dropped in water, a fresh egg will sink; a stale one won’t.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter23.vue?880759ca